import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import DisclaimProjectWidget from '../../../widgets/closeProject/DisclaimProjectWidget'
import { getDisclaimForm } from '../../../redux/actions/disclaimProject'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'

export default function DisclaimProjectStaff() {
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [projectId])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getDisclaimForm(proposalId)
      if (response.success) setSchemas(response.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {schemas?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schemas.forms.agreementDetails} />
        )}

        {schemas?.forms?.requestNote && (
          <>
            <DisclaimProjectWidget
              showCommandButton={!schemas?.forms?.disabled}
              schema={schemas.forms.requestNote}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  header: 'สละสิทธิ์โครงการ',
  subHeader: 'ข้อเสนอโครงการ ปิดเทอมสร้างสรรค์ และกิจกรรมสร้างเสริมสุขภาพ สำหรับเด็กและ เยาวชน',
  forms: {
    agreementDetails: {
      title: 'รายละเอียดการสละสิทธิ์โครงการ',
      content: 'ขอสละสิทธิ์โครงการนะครับ',
      datetime: {
        dateLabel: 'วันที่ : ',
        dateValue: '22 พฤษภาคม 2564',
        timeLabel: 'เวลา : ',
        timeValue: '11:35',
      },
      status: {
        statusLabel: 'สถานะ : ',
        statusValue: 'รออนุมัติสละสิทธิ์โครงการ',
      },
    },
    disclaimProject: {
      header: 'เสนอพิจารณาอนุมัติ สละสิทธิ์โครงการ',
      buttonText: 'เสนอพิจารณาอนุมัติ',
      requestNote: {
        name: 'requestNote',
        hint: 'หมายเหตุ',
        label: 'หมายเหตุ',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกหมายเหตุ',
          },
        ],
      },
    },
  },
}
